// extracted by mini-css-extract-plugin
export default {"popup":"popup-T7TlSxy6","animateFromTop":"animateFromTop-RtzvSiJF","compact":"compact-sba_ZZMQ","sm":"sm-S4maO2zz","md":"md-K0slSRDQ","lg":"lg-xwBPi8Jx"};